<div class="bg-primary-main flex min-h-screen flex-col justify-center py-12 sm:px-6 lg:px-8">
  <ngb-messages></ngb-messages>
  <div class="mt-6 sm:mx-auto sm:w-full sm:max-w-md">
    <div class="bg-white px-4 py-8 shadow sm:rounded-lg sm:px-10">
      <div class="mb-8 sm:mx-auto sm:w-full sm:max-w-md">
        <a [routerLink]="['/']" class="cursor-pointer">
          <img class="mx-auto h-16 w-auto rounded-md" src="assets/{{ logo }}" alt="Tper elearning" />
        </a>
        <p class="mt-6 text-center font-mono">v{{ appVersion }}</p>
      </div>

      <form [formGroup]="loginForm" (ngSubmit)="login()">
        <div>
          <label for="username" class="block text-sm font-medium leading-5 text-gray-700"> Username </label>
          <div class="mt-1 rounded-md shadow-sm">
            <input
              id="username"
              type="email"
              required
              [ngClass]="{ 'border-red-500': submitted && f.username.errors }"
              placeholder="es. example@example.com"
              name="username"
              formControlName="username"
              autofocus
              class="focus:outline-none focus:ring-blue block w-full appearance-none rounded-md border border-gray-300 px-3 py-2 placeholder-gray-400 transition duration-150 ease-in-out focus:border-blue-300 sm:text-sm sm:leading-5" />
            <div *ngIf="submitted && f.username.errors">
              <p *ngIf="f.username.errors.required" class="mt-3 text-xs text-red-600" role="alert">Inserisci uno username</p>
            </div>
          </div>
          <p *ngIf="errors?.email" class="mt-2 text-sm leading-4 text-red-600">
            {{ errors?.email }}
          </p>
        </div>

        <div class="mt-6">
          <label for="password" class="block text-sm font-medium leading-5 text-gray-700"> Password </label>
          <div class="mt-1 rounded-md shadow-sm">
            <input
              id="password"
              type="password"
              formControlName="password"
              placeholder="••••••••••"
              required
              [ngClass]="{ 'border-red-500': submitted && f.password.errors }"
              class="focus:outline-none focus:ring-blue block w-full appearance-none rounded-md border border-gray-300 px-3 py-2 placeholder-gray-400 transition duration-150 ease-in-out focus:border-blue-300 sm:text-sm sm:leading-5" />
            <div *ngIf="submitted && f.password.errors">
              <p *ngIf="f.password.errors.required" class="mt-3 text-xs text-red-600" role="alert">Inserisci una password</p>
            </div>
          </div>
        </div>

        <div class="mt-6 flex items-center justify-between">
          <!-- <div class="flex items-center">
            <input id="remember"
                   formControlName="remember"
                   type="checkbox"
                   class="w-4 h-4 border-gray-300 rounded focus:ring-primary-500 text-primary-main" />
            <label for="remember"
                   class="block ml-2 text-sm leading-5 text-gray-900">
              Ricordami
            </label>
          </div> -->

          <div class="text-sm leading-5">
            <a
              [routerLink]="['/forgot']"
              class="text-primary-main hover:text-main-cyan focus:outline-none font-medium transition duration-150 ease-in-out focus:underline">
              Ho dimenticato la password
            </a>
          </div>
        </div>

        <div class="mt-6">
          <span class="block w-full rounded-md shadow-sm">
            <button
              type="submit"
              [disabled]="loading"
              class="bg-primary-main hover:bg-main-cyan focus:outline-none focus:border-primary-main focus:ring-indigo active:bg-primary-main flex w-full justify-center rounded-md border border-transparent px-4 py-2 text-sm font-medium text-white transition duration-150 ease-in-out">
              <svg
                *ngIf="loading"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                class="mr-1 h-4 w-4 animate-spin self-center"
                width="100%"
                height="100%"
                viewBox="0 0 24 24"
                preserveAspectRatio="xMidYMid">
                <path
                  d="M 12 2 a 1 1 0 0 0 0 20 a 1 1 0 0 0 0 -2 a 1 1 0 0 1 0 -16 a 1 1 0 0 0 0 -2"
                  fill="#ffffff"
                  stroke="none"></path>
              </svg>
              {{ loading ? 'Accesso in corso…' : 'Login' }}
            </button>
          </span>
        </div>
      </form>
    </div>
  </div>
</div>
